<template>
  <v-row>
    <v-col cols="12">
      <ListFromTo
                  :title="loading ? 'Carregando ajudantes/assistentes...' : 'Ajudantes/Assistentes'"
                  :listFrom="lstLegalPeople"
                  :listTo="value"
                  @updated="submitUpdate"
                  listFromKey="name"
                  listToKey="name"
                  density="compact"
                  :bigList="true"
                  :loading="requestingApi">
        <template v-slot:search>
          <div>
            <v-form :submit="searchPeople">
              <v-text-field
                            label="Pesquisar pessoas pelo nome"
                            hide-details
                            v-model="searchText"
                            @click:append-inner="searchPeople"
                            clearable
                            append-inner-icon="mdi-magnify"
                            density="compact"
                            :loading="requestingApi"
                            :disabled="requestingApi"
                            @input="waitAndSearch">
              </v-text-field>
            </v-form>
          </div>
        </template>
      </ListFromTo>
    </v-col>
  </v-row>
</template>
<script>
import AutocompleteSelectSubGroup from './AutocompleteSelectSubGroup.vue';
import ListFromTo from "./ListFromTo.vue";
import api from '@/services'
export default {
  components: { ListFromTo, AutocompleteSelectSubGroup },
  props: {
    user: Object,
    modelValue: Object,
    eventId: Number,
    loading: Boolean,
  },
  emits: ["update:modelValue","loadEventStaff"],
  data() {
    return {
      requestingApi: null,
      timeoutSearchDelay: null,
      lstLegalPeople: [],
      searchText: null,
    };
  },
  created() {
    var vm = this;
    vm.$emit("loadEventStaff");
  },
  mounted() { },
  methods: {
    submitUpdate(eventStaff) {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.eventStaff
          .updateOrCreate({
            event_id: vm.eventId,
            legal_person_ids: eventStaff.map((i) => i.id),
          })
          .then((result) => {
            vm.$emit("updated", result);
            vm.$notify({
              type: "success",
              text: "Evento atualizado com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    searchPeople() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPerson
          .search({
            searchText: vm.searchText,
            types: [vm.$LEGAL_PEOPLE_TYPES_DIC.PADRAO],
            limit: 100
          })
          .then((result) => {
            vm.lstLegalPeople = result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    waitAndSearch() {
      const vm = this;

      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.searchPeople();
        }, 700);
      }
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {},
};
</script>